import React, { useEffect } from 'react';
import AudioSection from './AudioSection';
import { logSessionInfo } from '../../../../../services/logger';
import './LocalPlaybackView.scss';

/**
 * LocalPlaybackView component displays the recorded audio for playback
 * with options to confirm the mic is fixed or retest.
 * 
 * @param {Object} props - Component props.
 * @param {string} props.audioUrl - The blob URL of the recorded audio.
 * @param {Function} props.onFixed - Callback when user confirms mic is fixed.
 * @param {Function} props.onRetest - Callback when user wants to retest audio.
 * @param {Function} props.onCleanup - Callback to cleanup blob URL when navigating away.
 */
export default function LocalPlaybackView(props) {
  const { audioUrl, onFixed, onRetest, onCleanup } = props;

  // Cleanup blob URL when component unmounts
  useEffect(() => {
    return () => {
      if (onCleanup) {
        onCleanup();
      }
    };
  }, [onCleanup]);

  const handleFixed = () => {
    logSessionInfo('teacherTroubleshoot_ISSUES_RESOLVED_SELECTED', {});
    if (onFixed) {
      onFixed();
    }
  };

  const handleRetest = () => {
    logSessionInfo('teacherTroubleshoot_LOCAL_PLAYBACK_MORE_HELP_SELECTED', {});
    // Cleanup current recording before retesting
    if (onCleanup) {
      onCleanup();
    }
    if (onRetest) {
      onRetest();
    }
  };

  return (
    <div className="local-playback-view">
      <div className="local-playback-view__content">
        <div className="local-playback-view__audio-container">
          <AudioSection
            audioUrl={audioUrl}
            isLoading={false}
            audioError={!audioUrl}
          />
        </div>

        <div className="local-playback-view__tips-container">
          <div className="local-playback-view__tips-title">
            What to listen for:
          </div>
          <ul className="local-playback-view__tips-list">
            <li className="local-playback-view__tips-item">Can you hear yourself speaking?</li>
            <li className="local-playback-view__tips-item">Is the volume too loud or quiet?</li>
            <li className="local-playback-view__tips-item">Is there excessive background noise?</li>
          </ul>
        </div>
      </div>
      
      <div className="local-playback-view__button-container">
        <button 
          className="local-playback-view__button"
          onClick={handleFixed}
        >
          It's Fixed
        </button>
        <button 
          className="local-playback-view__button secondary"
          onClick={handleRetest}
        >
          More Help
        </button>
      </div>
    </div>
  );
}
